<template>
    <div>
        <div ref="editor" style="text-align:left"></div>
    </div>
</template>

<script>
import E from 'wangeditor';

export default {
  name: 'editor',
  props: {
    data: String,
  },
  data() {
    return {
      editorContent: '',
      editorId: '',
    };
  },
  mounted() {
    this.editorId = new E(this.$refs.editor);

    this.editorId.customConfig.onchange = (html) => {
      this.editorContent = html;
      if (this.editorId.txt.text()) {
        this.$emit('funcEditor', this.editorId.txt.html());
      } else {
        this.$emit('funcEditor', '');
      }
    };
    // 自定义菜单配置
    this.editorId.customConfig.menus = [
      'head', // 标题
      'bold', // 粗体
      'fontSize', // 字号
      'fontName', // 字体
      'italic', // 斜体
      'underline', // 下划线
      'strikeThrough', // 删除线
      'foreColor', // 文字颜色
      // 'backColor', // 背景颜色
      'link', // 插入链接
      // 'list', // 列表
      'justify', // 对齐方式
      'quote', // 引用
      // 'emoticon', // 表情
      'code', // 插入代码
      'undo', // 撤销
      'redo', // 重复
    ];
    this.editorId.create();
  },
  methods: {
    getContent() {
      this.$emit('funcEditor', this.editorContent.html());
    },
    handleClear() {
      this.editorId.txt.clear();
    },
  },
  watch: {
    data(val) {
      if (val) {
        this.editorId.txt.html(val);
      }
    },
  },
};
</script>

<style scoped>
</style>
